// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4385b5c0","455":"f60466d0","726":"63452396"}[chunkId] + ".chunk.js";
};